export const HOME = {
  navbar: 'mgs-navbar',
  navLogo: 'navbar-logo',
  navContact: 'nav-contact-btn',
  heroCtaPrimary: 'hero-cta-lets-connect',
  heroCtaSecondary: 'hero-cta-explore-ai',
  servicesGrid: 'services-grid',
  industriesGrid: 'industries-grid',
  achievementsRow: 'achievements-row',
  portfolioTabs: 'portfolio-tabs',
  caseStudyCarousel: 'case-study-carousel',
  valuesGrid: 'values-grid',
  technologiesTabs: 'technologies-tabs',
  testimonialsCarousel: 'testimonials-carousel',
  clientsMarquee: 'clients-marquee',
  ctaForm: 'cta-contact-form',
  ctaSubmit: 'cta-submit-btn',
  footer: 'mgs-footer',
  askVicky: 'ask-vicky-widget',
};
